<template>
    <div>
        <nav-breadcrumb :menu="[{label: '通知'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery,removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "BranchNoticeList",
        data(){
            return{
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '标题',
                        field: 'n__title'
                    },
                    {
                        label: '发布者',
                        field: 'n__poster',
                    },
                    {
                        label: '有效期',
                        field: 'n__frDate',
                        formatter: function (r,c,v) {
                                return   v+'至'+r.n__toDate

                        }
                    },
                    {
                        label: '发布时间',
                        field: 'n__createdDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            /*{
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                assignmentId: row.a__assignmentId
                                            }
                                        }
                                    )
                                }
                            },*/
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'edit',
                                            query: {
                                                noticeId: row.n__noticeId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                },
                                conditions: row=> {
                                    return new Date().getTime()< new Date(row.n__frDate).getTime() || new Date().getTime() > (new Date(row.n__toDate).getTime()+24*3600*1000-1)

                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        n__title:'',
                        n__createdDate:[],
                    },
                    columns: [

                        {
                            label: '标题',
                            component: 'el-input',
                            field: 'n__title',
                            span: 8
                        },
                        {
                            label: '发布日期',
                            component: 'date-range-picker',
                            field: 'n__createdDate',
                            op: ['gteq', 'lteq'],
                            span: 16
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.sort.dataField': 'n.createdDate',
                    'xlist.sort.order': 'desc'
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getBranchNoticeList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },

            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchNotice,
                    {
                        'n.noticeId' : row.n__noticeId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchNoticeList.vue